module.exports = __webpack_public_path__ + "static/media/school_1.d2f10279.png";